export default {
  topBarHeight: '64px',
  minPageHeight: 'calc(100vh - 220px)',
  mainDrawerWidth: '300px'
}
